/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ImportDlsgCertificateRequest {
  /**
  * PEM-encoded certificate body
  */
  'certificateBody': string;
  /**
  * PEM-encoded private key
  */
  'certificatePrivateKey': string;
  /**
  * Optional PEM-encoded certificate chain
  */
  'certificateChain'?: string | null;
  /**
  * AWS region where the DLSG gateway is deployed
  */
  'region': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "certificateBody",
      "baseName": "certificateBody",
      "type": "string",
      "format": ""
    },
    {
      "name": "certificatePrivateKey",
      "baseName": "certificatePrivateKey",
      "type": "string",
      "format": ""
    },
    {
      "name": "certificateChain",
      "baseName": "certificateChain",
      "type": "string",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ImportDlsgCertificateRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

